import { Browser, Device } from "@kakaopay-common/user-agent";
const APP_STORE_URL = {
  kakaotalk: {
    ios: "https://apps.apple.com/app/id362057947",
    and: "https://play.google.com/store/apps/details?id=com.kakao.talk"
  },
  kakaopay: {
    ios: "https://apps.apple.com/app/id1464496236",
    and: "https://play.google.com/store/apps/details?id=com.kakaopay.app"
  }
};
const moveToStore = () => {
  const res = window.confirm(
    "원활한 서비스 이용을 위해 최신 버전으로 업데이트 해주세요."
  );
  if (res) {
    const storeUrl = APP_STORE_URL[Browser.isKakaoPayApp() ? "kakaopay" : "kakaotalk"][Device.isIos() ? "ios" : "and"];
    window.location.href = storeUrl;
  }
};
export {
  moveToStore
};
